import { request } from "./apiClient";

export const favoriteService = {
  /**
   * Danh sách yêu thích — user từ JWT
   * GET /favorites/me
   */
  getUserFavorites: (token) => request(`/favorites/me`, { token }),

  /**
   * Thêm địa điểm vào yêu thích
   * POST /favorites — body: { locationId }
   */
  addFavorite: (token, locationId) =>
    request(`/favorites`, {
      method: "POST",
      token,
      body: { locationId },
    }),

  /**
   * Xoá — user từ JWT
   * DELETE /favorites/me/:locationId
   */
  removeFavorite: (token, locationId) =>
    request(`/favorites/me/${encodeURIComponent(locationId)}`, {
      method: "DELETE",
      token,
    }),

  /**
   * Kiểm tra yêu thích — user từ JWT
   * GET /favorites/me/check/:locationId
   */
  checkFavorite: (token, locationId) =>
    request(`/favorites/me/check/${encodeURIComponent(locationId)}`, { token }),

  /**
   * Số lượng yêu thích — user từ JWT
   * GET /favorites/me/count
   */
  getFavoriteCount: (token) => request(`/favorites/me/count`, { token }),

  /**
   * Toggle — user từ JWT, body { locationId }
   * POST /favorites/toggle
   */
  toggleFavorite: (token, locationId) =>
    request(`/favorites/toggle`, {
      method: "POST",
      token,
      body: { locationId },
    }),

  /**
   * Tạo link chia sẻ favorites
   * POST /favorites/share — body { locationIds, expiresInDays? }
   * Token optional (nếu có sẽ gắn createdBy)
   */
  createShare: (token, locationIds, { expiresInDays } = {}) =>
    request(`/favorites/share`, {
      method: "POST",
      token,
      body: { locationIds, expiresInDays },
    }),

  /**
   * Lấy nội dung link share
   * GET /favorites/share/:code
   */
  getShare: (code) => request(`/favorites/share/${encodeURIComponent(code)}`),

  /**
   * Import share vào favorites của user hiện tại
   * POST /favorites/me/import-share — body { code }
   */
  importShareToMe: (token, code) =>
    request(`/favorites/me/import-share`, {
      method: "POST",
      token,
      body: { code },
    }),
};
